import { useWatch } from "react-hook-form";
import { Link} from "react-router-dom";
import { IFormValues } from "../../../../../../types";
import { useHasScope } from "../../../../../../../../../../config/globalConfig";
import { BookingScope } from "../../../../../../../../types";
import { useTranslation } from "react-i18next";

const BusinessAgreementHelperText = () => {

    const hasScope = useHasScope;
    const { t } = useTranslation('booking');
    
    const businessAgreementCode = useWatch<IFormValues, 'otherDetails.customerCode'>({
        name: 'otherDetails.customerCode'
    });


    return (
        <>
            {hasScope(BookingScope.EnableSalesAndMarketingScopes) && hasScope(BookingScope.ViewBusinessAgreements) && !!businessAgreementCode && 
                <Link
                    to={`/salesmarketing/businessagreementlist?businessAgreementCode=${businessAgreementCode}`}
                    target="_blank"
                    style={{color: "black"}} 
                >
                    {t("label.detail")}
                </Link>
            }
        </>
    
    )

}

export default BusinessAgreementHelperText;